
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HistoriesView',
  created() {
    console.log('>>>>created>>>>')
  },
  data(){
    return {
      tabIndex: 0
    }
  }
});
